import React from 'react';
import { formatDateUS } from '@/utils/explorer';

interface Props {
  line1: string;
  active?: boolean;
  payload?: any;
  label?: string;
}

function CustomTooltip(props: Props) {
  const { payload, label, active, line1 } = props;

  if (active && payload && payload.length) {
    if (active) {
      let year = '';
      let month = '';
      let day = '';
      if (label && typeof label === 'string') {
        [year, month, day] = label.split('-');
      }
      return (
        <div className="flex flex-col items-center rounded bg-neutral-700 p-2 text-xs leading-normal">
          <div className="text-sm">{line1}</div>
          <div className="italic">
            {year && month && day
              ? formatDateUS(+year, +month, +day, true)
              : ''}
          </div>
        </div>
      );
    }
    return null;
  }
}

export default CustomTooltip;
